import Model from './utils/model'
import nexus from '@db2b/nexus-js'
import moment from 'moment'

export default {
  ...Model,
  options: {
    translations: {
      name: 'Client/Prospect'
    },
    name: 'customer',
    url: nexus.url('crm2', 'customers')
  },
  getBillingStep (customer) {
    if (customer.meta.document_flag_litigation_invoice_count) {
      let diff = moment().diff(customer.meta.document_flag_last_overdue_date, 'days')
      if (diff < 20) {
        return 2
      } else {
        return 3
      }
    } else if (customer.meta.document_flag_overdue_invoice_count) {
      return 1
    } else {
      return 0
    }
  },
  getFromRelations (models) {
    return new Promise((resolve, reject) => {
      nexus.get('crm2', 'customers', {
        params: {
          where: {
            id: {'IN': models.map(model => model.customer_id).join(',')}
          }
        }
      }).then(response => {
        resolve(response.data.data)
      }).catch(() => {
        reject()
      })
    })
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/model/customer.js